<script setup>
defineProps({
  pictograms: {
    type: Array,
    default: () => [],
  },
  icon: {
    type: String,
    default: 'align-left',
  },
  margin: {
    type: String,
    default: 'mb-14',
  },
});
</script>

<template>
  <div class="flex">
    <span :aria-label="$t('global.pictograms')"></span>

    <img
      v-for="(pictogram, index) in pictograms"
      :aria-label="pictogram.description"
      :key="index"
      class="w-[120px] mr-5 border-2 border-neutral-300 rounded-[10px]"
      v-optimized="{ size: 'small', src: pictogram.source }"
    />
  </div>
</template>
